import { useFormInstance } from '@adv-frontend/form-kit';
import { InvalidEmailModal } from '@/features/InvalidEmailModal';
import { InvalidPhoneModal } from '@/features/InvalidPhoneModal';
import { DIGITAL_ORDER_FORM_ID, orderForm } from '@/features/OrderForm';
import { OrderSubmissionError } from '@/features/OrderSubmissionError';
import { PayBoxModal } from '@/features/PayBoxModal';
import { type SchemaDigitalOrder } from '@/shared/api/openApi';
import { type UseModalControllerPayload } from '@/shared/lib/hooks';

interface ModalsProps {
    order: SchemaDigitalOrder;
    signature: string;
    storeSlug: string;
    payboxUrl: string;
    modals: {
        invalidEmail: UseModalControllerPayload;
        invalidPhone: UseModalControllerPayload;
        orderSubmissionError: UseModalControllerPayload;
        payBoxModal: UseModalControllerPayload;
    };
}

export const DigitalCheckoutModals = (props: ModalsProps) => {
    const { modals, payboxUrl } = props;
    const formInstance = useFormInstance({ form: orderForm, id: DIGITAL_ORDER_FORM_ID });

    const onSubmit = async () => {
        await formInstance.submit();
        modals.orderSubmissionError.onClose();
    };

    return (
        <>
            <PayBoxModal {...modals.payBoxModal} payboxUrl={payboxUrl} />
            <InvalidEmailModal {...modals.invalidEmail} />
            <InvalidPhoneModal {...modals.invalidPhone} />
            <OrderSubmissionError {...modals.orderSubmissionError} onSubmit={onSubmit} />
        </>
    );
};
